import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./themeHeaderNew.css";
import toggleIcon from "../../assets/images/toggle.svg";
import actionIcon from "../../assets/images/actionIcon.svg";
import bellIcon from "../../assets/images/bellIcon.svg";
import languageIcon from "../../assets/images/languageIcon.svg";
import newLanguageIcon from "../../assets/images/icons/languageIconUpdated.svg";
import questionIcon from "../../assets/images/questionIcon.svg";
import profileIcon from "../../assets/images/profileIcon.svg";
import downIcon from "../../assets/images/downIcon.svg";
import { allRoutes } from "../../assets/routes/allRoutes";
import { AuthContext } from "../../context/AuthContext";
import ActionItemsModal from "../containers/sidebar/common/ActionItem";
import { useTranslation } from "react-i18next";
import * as Storage from "../../store/LocalStorage";
import useConfig from "../../hooks/useConfig";
import useRTLContext from "../../hooks/useRTLContext";
import ReactTooltip from "react-tooltip";
import useCurrentUserContext from "../../hooks/useCurrentUserContext";
import logoIcon from "../../assets/images/awnLogo.svg";

const ThemeHeaderNav = ({ toggleSidebar, isCollapsed, noAccess }) => {
  const config = useConfig();
  const { currentUser } = useCurrentUserContext();
  console.log("current user: ", currentUser);
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();
  const [profileDropdown, setProfileDropdown] = useState(false);
  const [isModulesModalOpen, setIsModulesModalOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const route = allRoutes;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const currentLanguage = i18n.language;
    document.documentElement.lang = currentLanguage;
    document.documentElement.dir = currentLanguage === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    Storage.set(config?.translationKey, lng);
  };

  const handleMyProfile = () => {
    navigate(config?.myProfile);
  };

  const handleLogout = () => {
    Storage.clear();
    window.location.reload();
  };

  const hanldeChangePassword = () => {
    console.log("Change Password");
    navigate(allRoutes.forgotPassword);
  };

  const UserDisplay = ({ currentUser }) => {
    return (
      <div
        className={`
      flex items-center 
      ${isRTL ? "border-r" : "border-l"} border-gray-200 
      ${isRTL ? "pr-4 mr-4" : "pl-4 ml-4"}
      md:${isRTL ? "pr-3 mr-3" : "pl-3 ml-3"}
      hidden sm:flex
    `}
      >
        <div className="flex flex-col">
          <p className="text-xs text-gray-500 m-0 leading-tight">
            {t("Welcome")}
          </p>
          {isRTL ? (
            <p className="text-sm font-semibold text-gray-900 m-0 leading-tight whitespace-nowrap">
              {currentUser?.firstNameArb || currentUser?.firstName}{" "}
              {currentUser?.lastNameArb || currentUser?.lastName}
            </p>
          ) : (
            <p className="text-sm font-semibold text-gray-900 m-0 leading-tight whitespace-nowrap">
              {currentUser?.firstName} {currentUser?.lastName}
            </p>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={`header-section ${isCollapsed ? "collapsed" : ""}`}>
        {!noAccess ? (
          <img
            className="header-toggle"
            src={toggleIcon}
            alt="toggle icon"
            onClick={toggleSidebar}
          />
        ) : (
          <div className="header-logo-container">
            <img
              className="header-logo"
              src={logoIcon}
              alt="logo icon"
              // onClick={toggleSidebar}
            />
          </div>
        )}
        <div className="header-actions-wrapper">
          <div className="header-actions">
            {/* Action Items */}

            <button
              className="action-items-btn"
              onClick={() => setIsModulesModalOpen(!isModulesModalOpen)}
            >
              <img src={actionIcon} alt={t("action icon")} />
              <span className="header-action-label">
                {t("User Management System")}
              </span>
            </button>

            <button className="header-icon-btn">
              <img
                className="action-icon"
                onClick={() =>
                  changeLanguage(i18n.language === "ar" ? "en" : "ar")
                }
                src={newLanguageIcon}
                alt="language toggle icon"
                title={
                  i18n.language === "ar"
                    ? "Change language to English"
                    : "تغيير اللغة إلى العربية"
                }
              />
            </button>

            {currentUser && <UserDisplay currentUser={currentUser} />}

            {/* Icons */}
            {/* <button className="header-icon-btn">
              <img className="action-icon" src={bellIcon} alt="bell icon" />
            </button>
 
            <button className="header-icon-btn">
              <img
                className="action-icon"
                src={questionIcon}
                alt="question mark icon"
              />
            </button> */}

            {/* User Profile */}
            {/* User Profile */}
            <button
              className="profile-dropdown"
              onClick={() => setProfileDropdown(!profileDropdown)}
              ref={dropdownRef}
            >
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0",
                  flexShrink: 0,
                }}
              >
                {currentUser?.profilePicture?.fileUrl ? (
                  <img
                    src={currentUser?.profilePicture?.fileUrl}
                    alt="profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = profileIcon;
                    }}
                  />
                ) : (
                  <img
                    className="profile-icon"
                    src={profileIcon}
                    alt="profile icon"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                )}
              </div>
              <img src={downIcon} alt="down icon" />
              {profileDropdown && (
                <div className="profile-dropdown-container">
                  <button
                    className="profile-dropdown-item"
                    onClick={handleMyProfile}
                  >
                    {t("My Profile")}
                  </button>
                  <button
                    className="profile-dropdown-item"
                    onClick={hanldeChangePassword}
                  >
                    {t("Change Password")}
                  </button>
                  <button
                    className="profile-dropdown-item"
                    onClick={handleLogout}
                  >
                    {t("Logout")}
                  </button>
                </div>
              )}
            </button>
          </div>
        </div>
      </div>
      {isModulesModalOpen && (
        <ActionItemsModal
          isOpen={isModulesModalOpen}
          onClose={() => setIsModulesModalOpen(false)}
        />
      )}
    </>
  );
};

export default ThemeHeaderNav;
